import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../../src/routes/RouteWithTitle';
import { AccessControl } from '../../../..//components';
import {
  useNativeSearchAccessControl,
  NativeSearchAction,
} from '../../../../hooks/useNativeSearchAccessControl';
import { Loader } from '../../../conversationWidget/components/Loader';
import {
  CareerBuilderEdgeAdd,
  CareerBuilderEdgeNewAccount,
} from '../nativeSearchJobBoards/careerBuilderEdge';
import {
  CareerBuilderRDBAdd,
  CareerBuilderRDBNewAccount,
} from '../nativeSearchJobBoards/careerBuilderRDB';
import { CVLibraryAdd, CVLibraryNewAccount } from '../nativeSearchJobBoards/cvLibrary';
import { CWJobAdd, CWJobNewAccount } from '../nativeSearchJobBoards/cwJob';
import { DiceAdd, DiceNewAccount } from '../nativeSearchJobBoards/dice';
import { JobServeAdd, JobServeNewAccount } from '../nativeSearchJobBoards/jobServe';
import { JobSiteAdd, JobSiteNewAccount } from '../nativeSearchJobBoards/jobsite';
import { MonsterNewAccount } from '../nativeSearchJobBoards/monster';
import MonsterAccount from '../nativeSearchJobBoards/monsterAccount/MonsterAccount';
import { ResumeLibraryAdd, ResumeLibraryNewAccount } from '../nativeSearchJobBoards/resumeLibrary';
import { TechFetchAdd, TechFetchNewAccount } from '../nativeSearchJobBoards/techFetch';

export const NativeSearchSettingsRoutes = () => {
  const { access, owns } = useNativeSearchAccessControl([
    NativeSearchAction.VIEW_NATIVE_SEARCH_ACCOUNTS,
    NativeSearchAction.MANAGE_NATIVE_SEARCH_ACCOUNTS,
    NativeSearchAction.DELETE_JOB_BOARD_ACCOUNTS,
  ]);
  const [view, manage, deleteJobBoard] = access;
  const hasAccess = owns || view || manage || deleteJobBoard;
  const canManage = owns || manage;
  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteWithTitle title="Native Search Settings - Wisestep">
            {hasAccess == undefined ? <Loader /> : hasAccess ? <DiceAdd /> : <AccessControl />}
          </RouteWithTitle>
        }
      />
      <Route
        path="/cb-rdb"
        element={
          hasAccess == undefined ? (
            <Loader />
          ) : hasAccess ? (
            <CareerBuilderRDBAdd />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/cb-edge"
        element={
          hasAccess == undefined ? (
            <Loader />
          ) : hasAccess ? (
            <CareerBuilderEdgeAdd />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/techFetch"
        element={
          hasAccess == undefined ? <Loader /> : hasAccess ? <TechFetchAdd /> : <AccessControl />
        }
      />
      <Route
        path="/cv-library"
        element={
          hasAccess == undefined ? <Loader /> : hasAccess ? <CVLibraryAdd /> : <AccessControl />
        }
      />
      <Route
        path="/resume-library"
        element={
          hasAccess == undefined ? <Loader /> : hasAccess ? <ResumeLibraryAdd /> : <AccessControl />
        }
      />
      <Route
        path="/monster"
        element={
          hasAccess == undefined ? <Loader /> : hasAccess ? <MonsterAccount /> : <AccessControl />
        }
      />
      <Route
        path="/job-serve"
        element={
          hasAccess == undefined ? <Loader /> : hasAccess ? <JobServeAdd /> : <AccessControl />
        }
      />
      <Route
        path="/cw-job"
        element={hasAccess == undefined ? <Loader /> : hasAccess ? <CWJobAdd /> : <AccessControl />}
      />
      <Route
        path="/job-site"
        element={
          hasAccess == undefined ? <Loader /> : hasAccess ? <JobSiteAdd /> : <AccessControl />
        }
      />

      <Route
        path="/dice-add"
        element={
          canManage == undefined ? <Loader /> : canManage ? <DiceNewAccount /> : <AccessControl />
        }
      />
      <Route
        path="/cb-rdb-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <CareerBuilderRDBNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/cb-edge-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <CareerBuilderEdgeNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/techFetch-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <TechFetchNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/cv-library-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <CVLibraryNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/resume-library-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <ResumeLibraryNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/monster-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <MonsterNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/job-serve-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <JobServeNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/cw-job-add"
        element={
          canManage == undefined ? <Loader /> : canManage ? <CWJobNewAccount /> : <AccessControl />
        }
      />
      <Route
        path="/job-site-add"
        element={
          canManage == undefined ? (
            <Loader />
          ) : canManage ? (
            <JobSiteNewAccount />
          ) : (
            <AccessControl />
          )
        }
      />
    </Routes>
  );
};
